module.exports = __webpack_public_path__ + "img/thumbnail_StripedSkunk_j_normal.00e4528d.png";